const STATE_KEY = 'elephant_game_state';
const TUTORIAL_KEY = 'elephant_tutorial_seen';

export interface GameState {
  bestScore: number;
  totalPlays: number;
  lastPlayedAt: number;
  history: Array<{ score: number; maxStage: number; playedAt: number }>;
}

const DEFAULT_STATE: GameState = {
  bestScore: 0,
  totalPlays: 0,
  lastPlayedAt: 0,
  history: [],
};

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // localStorage unavailable (private mode, quota) — silently no-op
  }
}

export function loadState(): GameState {
  const raw = safeGet(STATE_KEY);
  if (!raw) return { ...DEFAULT_STATE };
  try {
    const parsed = JSON.parse(raw) as Partial<GameState>;
    return { ...DEFAULT_STATE, ...parsed };
  } catch {
    return { ...DEFAULT_STATE };
  }
}

export function saveState(state: GameState): void {
  safeSet(STATE_KEY, JSON.stringify(state));
}

export function isTutorialSeen(): boolean {
  return safeGet(TUTORIAL_KEY) === '1';
}

export function markTutorialSeen(): void {
  safeSet(TUTORIAL_KEY, '1');
}

export function resetTutorialSeen(): void {
  safeSet(TUTORIAL_KEY, '0');
}

export interface GameResult {
  score: number;
  maxStage: number;
}

export function saveGameResult(result: GameResult): { isNewBest: boolean; bestScore: number } {
  const state = loadState();
  const isNewBest = result.score > state.bestScore;
  state.bestScore = Math.max(state.bestScore, result.score);
  state.totalPlays += 1;
  state.lastPlayedAt = Date.now();
  state.history.unshift({
    score: result.score,
    maxStage: result.maxStage,
    playedAt: Date.now(),
  });
  state.history = state.history.slice(0, 10);
  saveState(state);
  return { isNewBest, bestScore: state.bestScore };
}

export function getMockRank(score: number): number {
  if (score > 3000) return Math.floor(Math.random() * 50) + 1;
  if (score > 1500) return Math.floor(Math.random() * 200) + 50;
  return Math.floor(Math.random() * 500) + 200;
}
